import { render, staticRenderFns } from "./TeacherWork.vue?vue&type=template&id=254894f6&"
import script from "./TeacherWork.vue?vue&type=script&lang=ts&"
export * from "./TeacherWork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports